export const getLanguage = ({ texts: { language } }) => language;

export const getTextsData = ({ texts: { data, language } }) => data[language];
